// orAmenities
export const FILTER_GROUP_ON_SITE_LAUNDRY = ['l1', 'b4'] as const
